import enviro from 'enviro';
import Products from 'merchandise-lib/constants/Product';
export const TrialIds = {
  SALES_ENTERPRISE: 1,
  MARKETING_ENTERPRISE: 2,
  SERVICE_ENTERPRISE: 3,
  MARKETING_PRO: 4,
  CMS_PROFESSIONAL: 7,
  SALES_PROFESSIONAL: 8,
  SERVICE_PROFESSIONAL: 9,
  CMS_ENTERPRISE: enviro.isProd() ? 18 : 17,
  // Legacy Operations Hub Trial IDs
  OPERATIONS_PROFESSIONAL: enviro.isProd() ? 35096 : 43098,
  OPERATIONS_ENTERPRISE: enviro.isProd() ? 52399 : 70192,
  DATA_PROFESSIONAL: enviro.isProd() ? 247334 : 349115,
  DATA_ENTERPRISE: enviro.isProd() ? 247335 : 349116,
  MARKETING_PLUS_PROFESSIONAL_BUNDLE: enviro.isProd() ? 200098 : 270355,
  MARKETING_PLUS_ENTERPRISE_BUNDLE: enviro.isProd() ? 200097 : 270725,
  CRM_SUITE_STARTER_BUNDLE: enviro.isProd() ? 222377 : 318128,
  COMMERCE_PROFESSIONAL: enviro.isProd() ? 241458 : 349410,
  COMMERCE_ENTERPRISE: enviro.isProd() ? 241459 : 349411
};
export const apiNameToTrialIds = {
  [Products.SALES_HUB_ENTERPRISE]: TrialIds.SALES_ENTERPRISE,
  [Products.MARKETING_HUB_ENTERPRISE]: TrialIds.MARKETING_ENTERPRISE,
  [Products.SERVICE_HUB_ENTERPRISE]: TrialIds.SERVICE_ENTERPRISE,
  [Products.MARKETING_HUB_PROFESSIONAL]: TrialIds.MARKETING_PRO,
  [Products.CMS_HUB_PROFESSIONAL]: TrialIds.CMS_PROFESSIONAL,
  [Products.SALES_HUB_PROFESSIONAL]: TrialIds.SALES_PROFESSIONAL,
  [Products.SERVICE_HUB_PROFESSIONAL]: TrialIds.SERVICE_PROFESSIONAL,
  [Products.CMS_HUB_ENTERPRISE]: TrialIds.CMS_ENTERPRISE,
  [Products.OPERATIONS_HUB_PROFESSIONAL]: TrialIds.DATA_PROFESSIONAL,
  [Products.OPERATIONS_HUB_ENTERPRISE]: TrialIds.DATA_ENTERPRISE,
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: TrialIds.MARKETING_PLUS_PROFESSIONAL_BUNDLE,
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: TrialIds.MARKETING_PLUS_ENTERPRISE_BUNDLE,
  [Products.CRM_SUITE_STARTER_BUNDLE]: TrialIds.CRM_SUITE_STARTER_BUNDLE,
  [Products.COMMERCE_HUB_PROFESSIONAL]: TrialIds.COMMERCE_PROFESSIONAL,
  [Products.COMMERCE_HUB_ENTERPRISE]: TrialIds.COMMERCE_ENTERPRISE
};